import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "breadcrumbs__parent-category-separator"
}
const _hoisted_2 = {
  key: 0,
  class: "breadcrumbs__category"
}

import { computed } from 'vue';

export interface Breadcrumb {
  url?: string;
  name?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumbs',
  props: {
  category: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props



const parents = computed(() => {
  return props.category?.parents?.filter((p: any) => p.url && p.name) || [];
});

const hasParents = computed(() => {
  return parents.value.length > 0;
});

const category = computed(() => {
  if (props.category?.name && props.category?.url) {
    return props.category;
  }

  return null;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['breadcrumbs', !_unref(hasParents) ? 'breadcrumbs--hidden' : ''])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(parents), (parent, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "breadcrumbs__parent-category",
        key: parent.url
      }, [
        _createVNode(_component_router_link, {
          to: parent.url,
          class: "breadcrumbs__parent-category-link"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(parent.name), 1)
          ]),
          _: 2
        }, 1032, ["to"]),
        (
          idx < _unref(parents).length - 1 || (idx === _unref(parents).length - 1 && _unref(category))
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, " / "))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_unref(category))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: _unref(category).url,
            class: "breadcrumbs__category-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(category).name), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})